import addClass from './addClass';
import removeClass from './removeClass';

// ----------------------------------------------------------------------------

function switchClass(element: HTMLElement, oldClass: string, newClass: string): void {
    removeClass(element, oldClass);
    addClass(element, newClass);
}

// ----------------------------------------------------------------------------

export default switchClass;
